import { Component } from '@angular/core';
import { PaymentRequestsListComponent } from '../../../../components/admin-dashboard-component/payment-requests-component/payment-requests-list-component/payment-requests-list-component';

@Component({
  selector: 'app-payment-requests-list',
  standalone: true,
  imports: [PaymentRequestsListComponent],
  templateUrl: './payment-requests-list.html',
  styleUrl: './payment-requests-list.scss',
})
export class PaymentRequestsList {}